function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sanjiangOrderIntegralLogApi } from '@/api/sanjiangApi.js';
export default {
  name: 'FudouDetailComponent',
  props: {
    /**
     * 订单ID - 用于获取福豆记录
     */
    orderId: {
      type: [String, Number],
      required: true
    },
    /**
     * 福豆总数
     */
    totalFudou: {
      type: [String, Number],
      default: 0
    },
    /**
     * 是否显示组件
     */
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // 福豆记录数据
      fudouRecords: [],
      loading: false
    };
  },
  watch: {
    /**
     * 监听visible变化，显示时获取数据
     */
    visible: {
      handler: function handler(newVal) {
        if (newVal && this.orderId) {
          this.fetchFudouRecords();
        }
      },
      immediate: true
    },
    /**
     * 监听orderId变化，重新获取数据
     */
    orderId: {
      handler: function handler(newId) {
        if (newId && this.visible) {
          this.fetchFudouRecords();
        }
      }
    }
  },
  methods: {
    /**
     * 获取福豆记录数据
     */
    fetchFudouRecords: function () {
      var _fetchFudouRecords = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.loading = true;
              console.log('获取福豆记录，订单ID:', this.orderId);

              // 调用真实的API接口
              _context.n = 1;
              return sanjiangOrderIntegralLogApi(this.orderId);
            case 1:
              response = _context.v;
              console.log('福豆记录API响应:', response);

              // 根据接口返回的数据结构处理数据
              if (response) {
                // 接口返回的是数组格式
                this.fudouRecords = response.map(function (item) {
                  return {
                    id: item.id,
                    cardId: item.cardId,
                    createTime: item.createTime,
                    type: item.type,
                    // 0-使用, 1-获得
                    amount: item.integral || 0,
                    // 福豆数量
                    description: item.orderName || '福豆记录',
                    orderNo: item.orderNo,
                    userName: item.userName,
                    phone: item.phone,
                    cardName: item.cardName
                  };
                });
              } else {
                this.fudouRecords = [];
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取福豆记录失败:', _t);
              this.$message.error('获取福豆记录失败');
              this.fudouRecords = [];
            case 3:
              _context.p = 3;
              this.loading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2, 3, 4]]);
      }));
      function fetchFudouRecords() {
        return _fetchFudouRecords.apply(this, arguments);
      }
      return fetchFudouRecords;
    }(),
    /**
     * 格式化日期时间
     * @param {Object} row - 表格行数据
     * @param {Object} column - 表格列配置
     * @param {string} cellValue - 单元格值
     * @returns {string} 格式化后的日期时间
     */
    formatDateTime: function formatDateTime(row, column, cellValue) {
      if (!cellValue) return '--';
      return cellValue;
    },
    /**
     * 获取类型标签样式
     * @param {number} type - 记录类型 (0-使用, 1-获得)
     * @returns {string} Element UI标签类型
     */
    getTypeTagType: function getTypeTagType(type) {
      // 根据接口返回的数字类型进行判断
      return type === 1 ? 'success' : 'warning';
    },
    /**
     * 获取类型显示文本
     * @param {number} type - 记录类型 (0-使用, 1-获得)
     * @returns {string} 类型显示文本
     */
    getTypeText: function getTypeText(type) {
      // 根据接口返回的数字类型进行判断
      return type === 1 ? '获得' : '使用';
    },
    /**
     * 获取金额样式类名
     * @param {number} type - 记录类型 (0-使用, 1-获得)
     * @returns {string} CSS类名
     */
    getAmountClass: function getAmountClass(type) {
      return type === 1 ? 'amount-earn' : 'amount-use';
    },
    /**
     * 格式化金额显示
     * @param {number} amount - 金额
     * @param {number} type - 类型 (0-使用, 1-获得)
     * @returns {string} 格式化后的金额
     */
    formatAmount: function formatAmount(amount, type) {
      var prefix = type === 1 ? '+' : '-';
      return "".concat(prefix).concat(amount);
    }
  }
};